import React from 'react';
import { Button, Flex, Stack } from '@grubhubprod/gh-cookbook-react';
import { useCreditCardIframe } from 'src/components/CreditCardFormIframe/useCreditCardIframe';
import { CreditCardFormIframe } from 'src/components/CreditCardFormIframe/CreditCardFormIframe';

export interface EnterpriseInvoicePaymentCreditCardFormProps {
  corpId: string;
  onClose: () => void;
  onSuccess: () => void;
  onError: () => void;
}

export function EnterpriseInvoicePaymentCreditCardForm({
  corpId,
  onClose,
  onSuccess,
  onError,
}: EnterpriseInvoicePaymentCreditCardFormProps): JSX.Element {
  const {
    onIframeSubmit,
    iframeContainerId,
    cardIsValid,
    isSubmitting,
    isLoadingComponent,
  } = useCreditCardIframe({
    corpId,
    onSuccess,
    onError,
    idSuffix: 'enterprise-invoice-payment',
  });

  return (
    <>
      <CreditCardFormIframe
        id={iframeContainerId}
        isLoadingComponent={isLoadingComponent}
      />
      <Flex>
        <Stack x="xx-lg">
          <Button
            variant="primary"
            buttonSize="medium"
            disabled={!cardIsValid || isSubmitting}
            isLoading={isSubmitting}
            onClick={(evt) => {
              evt.preventDefault();
              onIframeSubmit();
            }}
          >
            Save credit card
          </Button>
        </Stack>
        <Button
          type="button"
          variant="tertiary"
          buttonSize="medium"
          onClick={onClose}
        >
          Cancel
        </Button>
      </Flex>
    </>
  );
}
